import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=1926d112&"
import script from "./LeadList.vue?vue&type=script&lang=js&"
export * from "./LeadList.vue?vue&type=script&lang=js&"
import style0 from "./LeadList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports